import api from "./api";

export const getPublicKbHome = async () => {
    const res = await api.get("/public/kb/home");
    return res.data;
};

export const searchPublicKbArticles = async (params = {}) => {
    const res = await api.get("/public/kb/articles", { params });
    return res.data;
};

export const getPublicKbArticle = async (slug) => {
    const res = await api.get(`/public/kb/articles/${slug}`);
    return res.data;
};